class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.linkUrl = this.summary && this.summary.getAttribute('data-link-url');
    this.closeTimeout = null;

    // Handle click on summary for "Sklep" link
    // On mobile, tapping should toggle the menu instead of navigating away
    // On desktop, it should navigate normally
    if (this.summary && this.linkUrl) {
      this.summary.addEventListener('click', (event) => {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        if (!isDesktop) {
          // On mobile, prevent navigation and toggle menu
          event.preventDefault();
          const isOpen = this.mainDetailsToggle.hasAttribute('open');
          if (isOpen) {
            this.close();
          } else {
            this.mainDetailsToggle.setAttribute('open', true);
            this.summary.setAttribute('aria-expanded', true);
          }
        } else {
          // On desktop, navigate to the URL
          window.location.href = this.linkUrl;
        }
      });
    }

    // Desktop hover behaviour: open on mouse enter, close on mouse leave
    // Keep menu open when hovering over both summary and content
    const handleMouseEnter = () => {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (!isDesktop) return;
      
      // Clear any pending close timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', true);
        if (this.summary) {
          this.summary.setAttribute('aria-expanded', true);
        }
      }
    };

    const handleMouseLeave = () => {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (!isDesktop) return;
      
      // Add a small delay before closing to allow moving between summary and content
      this.closeTimeout = setTimeout(() => {
        this.close();
        this.closeTimeout = null;
      }, 150);
    };

    // Add hover handlers to the entire header-menu element (includes summary)
    this.addEventListener('mouseenter', handleMouseEnter);
    this.addEventListener('mouseleave', handleMouseLeave);

    // Also add hover handlers to the content area
    if (this.content) {
      this.content.addEventListener('mouseenter', handleMouseEnter);
      this.content.addEventListener('mouseleave', handleMouseLeave);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
